/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import io from 'socket.io-client';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/auth';
import LayoutMap from '../layouts/layoutMap';
import LayoutBackOffice from '../layouts/index';
import { baseURL } from '../services/api';

import AuthRoute from './authRoute';

import Login from '../pages/Login/index';
import Map from '../pages/Map';
// import MapTeste from '../pages/Map/teste';
import Fazendas from '../pages/Listas/Fazendas';
import Produtores from '../pages/Listas/Produtores';
import Perfil from '../pages/Usuario/Perfil';
import Consultores from '../pages/Listas/Consultores';
import Usuarios from '../pages/Listas/Usuarios';
import Operacional from '../pages/Listas/Operacional';
import Chat from '../pages/Chat';
import Notifications from '../pages/Notifications';
import GestaoColeta from '../pages/Listas/GestaoColeta';
import Movimentacoes from '../pages/Listas/MovimentacaoFinanceira';
import Faq from '../pages/Faq';
// import Safras from '../pages/Listas/Safras';
import PlugField from '../pages/PlugField';

const Routes = () => {
  const { user, signed, loading, setSocket, setMsgTodos, setMsgMinhas } =
    useAuth();

  useEffect(() => {
    if (signed) {
      const newSocket = io(baseURL, {
        extraHeaders: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      });
      setSocket(newSocket);
      newSocket?.on('connect', () => {
        console.log('ws connected');
      });
      newSocket?.on('messages', (data) => {
        setMsgTodos(data?.semAtendente);
        setMsgMinhas(data?.minhas);
      });
      newSocket?.on('message', (data) => {
        if (window.location.pathname !== '/chat') {
          toast.info('Nova mensagem!', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        if (data?.semAtendente || data?.entered) {
          if (data?.entered) {
            if (data?.atendente === user?.id) {
              setMsgMinhas((oldMinha) => {
                const msgMinhasNew = Array.from(oldMinha);
                const obj = {
                  _id: data.sala,
                  mensagens: data?.mensagens,
                };
                msgMinhasNew.push(obj);
                return msgMinhasNew;
              });
            }
          }

          setMsgTodos((old) => {
            const msgSemAtendentesNew = Array.from(old);

            const temSala = msgSemAtendentesNew.some(
              (s) => s._id === data?.sala
            );
            if (temSala) {
              for (
                let index = 0;
                index < msgSemAtendentesNew.length;
                index += 1
              ) {
                const element = msgSemAtendentesNew[index];
                if (element?._id === data?.sala) {
                  if (data?.entered) {
                    msgSemAtendentesNew.splice(index, 1);
                  } else {
                    element?.mensagens?.push(data);
                  }
                }
              }
            } else {
              const obj = {
                _id: data.sala,
                mensagens: [data],
              };
              msgSemAtendentesNew.push(obj);
            }
            return msgSemAtendentesNew;
          });
        } else {
          setMsgMinhas((old) => {
            const msgMinhasNew = Array.from(old);

            for (let index = 0; index < msgMinhasNew.length; index += 1) {
              const element = msgMinhasNew[index];

              if (element?._id === data?.sala) {
                if (data?.concluido) {
                  msgMinhasNew.splice(index, 1);
                } else {
                  element?.mensagens?.push(data);
                }
              }
            }
            return msgMinhasNew;
          });
        }
      });
      return () => newSocket.close();
    }
  }, [setSocket, signed, user]);

  return (
    <BrowserRouter>
      <Switch>
        {signed || loading ? (
          <Switch>
            <Route path={['/mapa', '/teste']}>
              <Switch>
                <LayoutMap>
                  <AuthRoute path="/mapa/:id/:idSafra" exact component={Map} />
                  {/* <AuthRoute path="/teste" exact component={MapTeste} /> */}
                </LayoutMap>
              </Switch>
            </Route>
            <Route
              path={[
                '/fazendas',
                '/produtores',
                '/consultores',
                '/perfil',
                '/usuarios',
                '/operacional',
                '/chat',
                '/push',
                '/gestao-coleta',
                '/financeiro',
                '/plugfield',
                '/faq',
              ]}
            >
              <Switch>
                <LayoutBackOffice>
                  <AuthRoute path="/fazendas" exact component={Fazendas} />
                  <AuthRoute path="/perfil" exact component={Perfil} />
                  <AuthRoute path="/produtores" exact component={Produtores} />
                  <AuthRoute path="/usuarios" exact component={Usuarios} />
                  <AuthRoute path="/chat" exact component={Chat} />
                  <AuthRoute
                    path="/operacional"
                    exact
                    component={Operacional}
                  />
                  <AuthRoute path="/push" exact component={Notifications} />
                  <AuthRoute
                    path="/gestao-coleta"
                    exact
                    component={GestaoColeta}
                  />
                  <AuthRoute
                    path="/consultores"
                    exact
                    component={Consultores}
                  />
                  <AuthRoute
                    path="/financeiro"
                    exact
                    component={Movimentacoes}
                  />
                  <AuthRoute path="/Faq" exact component={Faq} />
                  <AuthRoute path="/plugfield" exact component={PlugField} />
                </LayoutBackOffice>
              </Switch>
            </Route>

            <Redirect to="/fazendas" />
          </Switch>
        ) : (
          <>
            <Route path="/" exact component={Login} />
            <Redirect to="/" />
          </>
        )}
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
